import { Show, createSignal, onCleanup, onMount } from "solid-js";
import { Portal } from "solid-js/web";
import { clsx } from "~/utils/classes";
import client from "~/utils/client";
import { c, stylex } from "~/utils/styles";
import { Spacer } from "./Space";

export const ServerAvailabilityChecker = () => {
	const [serverAvailable, setServerAvailable] = createSignal(null as boolean | null);
	const [serverEverAvailable, setServerEverAvailable] = createSignal(null as boolean | null);

	onMount(() => {
		console.debug("ServerAvailabilityChecker mounted");
		let interval = setInterval(() => {
			client
				.get("/api/health", { timeout: 10000 })
				.then((_resp) => {
					setServerAvailable(true);
					if (serverEverAvailable() === false) {
						window.location.reload();
					}
					setServerEverAvailable(true);
				})
				.catch(() => {
					setServerAvailable(false);
					if (serverEverAvailable() === null) {
						setServerEverAvailable(false);
					}
				});
		}, 1000);
		onCleanup(() => {
			clearInterval(interval);
		});
	});

	return (
		<Portal mount={document.body}>
			<Show when={serverAvailable() === false}>
				<div class={clsx("fixed  z-2000 bottom-0 right-0 cursor-pointer")}>
					<div
						class={clsx(" bg-gray-94 rounded relative p-8  column mr-4 mb-4 row items-center")}
						style={stylex(c.shadow(0, 10, 60, 0, c.hsl(0, 0, 0, 50)))}
					>
						<i class="fas fa-warning text-xl text-red-50" />
						<Spacer width={12} />
						<p class="font-semibold text-gray-10">Server unavailable</p>
					</div>
				</div>
			</Show>
		</Portal>
	);
};
